import Vue from "vue";
import VueRouter from "vue-router";
// import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    redirect: "/home",
    component: Layout,
    name: "Root",
    children: [
        {
            path: "/Home",
            name: "Home",
            meta: {
                navbarHidden: false,
                name: "首页",
                parentName: "首页"
            },
            component: () =>
                import("@/views/home")
        },
        {
            path: "/ProjectAnnouncement",
            name: "ProjectAnnouncement",
            meta: {
                navbarHidden: false,
                name: "项目公告",
                parentName: "项目公告"
            },
            component: () =>
                import("@/views/project-announcement")
        },
        {
            path: "/ProjectAnnouncementDetail",
            name: "ProjectAnnouncementDetail",
            meta: {
                navbarHidden: true,
                name: "项目公告详情",
                parentName: "项目公告详情"
            },
            component: () =>
                import("@/views/project-announcement/detail.vue")
        },
        {
            path: "/MortgageAnnouncement",
            name: "MortgageAnnouncement",
            meta: {
                name: "抵押公告",
                parentName: "抵押公告"
            },
            component: () =>
                import("@/views/mortgage-announcement")
        },
        // 挂牌申请
        {
            path: "/PropertyExchangeCenter",
            mainPath: "/PropertyExchangeCenter/TransactionProject",
            name: "PropertyExchangeCenter",
            meta: {
                name: "产权流转交易中心",
                parentName: "产权流转交易中心",
                navbarHidden: true,
            },
            component: () =>
                import("@/views/property-exchange-center"),
            children: [{
                path: "/PropertyListingApplication",
                name: "PropertyListingApplication",
                hidden: true,
                meta: {
                    name: "挂牌申请",
                    parentName: "产权流转交易中心"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/property-listing-application/index.vue"
                    )
            },
            {
                path: "/ForestRight",
                name: "ForestRight",
                hidden: true,
                meta: {
                    name: "挂牌申请-林权",
                    parentName: "产权流转交易中心"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/property-listing-application/forestRight.vue"
                    )
            },
            {
                path: "/RuralLand",
                name: "RuralLand",
                hidden: true,
                meta: {
                    name: "挂牌申请-土地",
                    parentName: "产权流转交易中心"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/property-listing-application/ruralLand.vue"
                    )
            },
            {
                path: "/Custom",
                name: "Custom",
                hidden: true,
                meta: {
                    name: "挂牌申请-自定义",
                    parentName: "产权流转交易中心"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/property-listing-application/custom.vue"
                    )
            },
            {
                path: "/Hanger",
                name: "Hanger",
                hidden: true,
                meta: {
                    name: "挂牌申请-增减挂钩",
                    parentName: "产权流转交易中心"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/property-listing-application/hanger.vue"
                    )
            },
            {
                path: "/PropertyProjectDetails",
                name: "PropertyProjectDetails",
                hidden: true,
                meta: {
                    name: "项目详情",
                    parentName: "产权流转交易中心"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/property-project-details/index.vue"
                    )
            },
            {
                path: "/OfflineProjectDetails",
                name: "OfflineProjectDetails",
                hidden: true,
                meta: {
                    name: "线下项目详情",
                    parentName: "线下项目"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/offline-project-details/index.vue"
                    )
            },
            {
                path: "infoCollection",
                name: "infoCollection",
                hidden: true,
                meta: {
                    name: "信息采集",
                    parentName: "产权流转交易中心"
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/info-collection"
                    )
            },
            ]
        },
        // 个人中心
        {
            path: "/Profile",
            name: "Profile",
            meta: {
                navbarHidden: true,
                parentName: "个人中心"
            },
            component: () =>
                import("@/views/profile/index.vue"),
            children: [{
                path: "/managementPersonal",
                name: "managementPersonal",
                meta: {
                    name: "账户管理",
                    parentName: "首页"
                },
                component: () =>
                    import("@/views/profile/management-personal.vue")
            },
            {
                path: "/InfoCollection",
                name: "InfoCollection",
                redirect: '/PropertyExchangeCenter/infoCollection',
                meta: {
                    name: '信息采集',
                }
            },
            {
                path: '/MyApplyList',
                name: 'MyApplyList',
                meta: {
                    name: "我的挂牌"
                },
                component: () =>
                    import("@/views/my/my-apply/list.vue")
            },
            {
                path: '/MyApplyForestDetail',
                name: 'MyApplyForestDetail',
                meta: {
                    name: "挂牌详情-林权",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-apply/detail/my-apply-forest-detail.vue")
            },
            {
                path: '/MyApplyRuralDetail',
                name: 'MyApplyRuralDetail',
                meta: {
                    name: "挂牌详情-土地",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-apply/detail/my-apply-rural-detail.vue")
            },
            {
                path: '/MyApplyCustomDetail',
                name: 'MyApplyCustomDetail',
                meta: {
                    name: "挂牌详情-自定义",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-apply/detail/my-apply-custom-detail.vue")
            },
            {
                path: '/MyApplyHangerDetail',
                name: 'MyApplyHangerDetail',
                meta: {
                    name: "挂牌详情-自定义",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-apply/detail/my-apply-hanger-detail.vue")
            },
            // 我的竞买 => 我的申请
            {
                path: '/myHanger',
                name: 'myHanger',
                meta: {
                    name: "我的申请"
                },
                component: () =>
                    import("@/views/my/my-hanger/list.vue")
            },
            {
                path: '/myAuction',
                name: 'myAuction',
                meta: {
                    name: "我的竞价"
                },
                component: () =>
                    import("@/views/my/my-auction/list.vue")
            },

            {
                path: '/myHangerDetail',
                name: 'myHangerDetail',
                meta: {
                    name: "申请详情",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-hanger/detail/my-hanger-detail.vue")
            },
            {
                path: '/myInvest',
                name: 'myInvest',
                meta: {
                    name: "我的投资"
                },
                component: () =>
                    import("@/views/my/my-invest/list.vue")
            },
            {
                path: '/investDetail',
                name: 'InvestDetail',
                meta: {
                    name: "投资详情",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-invest/investDetail.vue")
            },
            {
                path: '/investSureBook',
                name: 'investSureBook',
                meta: {
                    name: "成交确认书",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-invest/sureBook.vue")
            },
            {
                path: '/myAsset',
                name: 'myAsset',
                meta: {
                    name: "我的资产"
                },
                component: () =>
                    import("@/views/my/my-asset/list.vue")
            },
            {
                path: "/myAccount",
                name: "myAccount",
                meta: {
                    name: "我的账户"
                },
                component: () =>
                    import("@/views/my/my-account/list.vue")
            },
            {
                path: '/myLoan',
                name: 'myLoan',
                meta: {
                    name: "我的贷款"
                },
                component: () =>
                    import("@/views/my/my-loan/list.vue")
            },
            {
                path: '/mySubsidy',
                name: 'mySubsidy',
                meta: {
                    name: "我的补贴",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-subsidy/list.vue")
            },
            {
                path: '/mySubsidyDetail',
                name: 'mySubsidyDetail',
                meta: {
                    name: "我的补贴未通过",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-subsidy/detail.vue")
            },
            {
                path: '/myCertificate',
                name: 'myCertificate',
                meta: {
                    name: "我的证书"
                },
                component: () =>
                    import("@/views/my/my-certificate/list.vue")
            },
            {
                path: '/myCertificateDetail',
                name: 'myCertificateDetail',
                meta: {
                    name: "我的证书详情",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-certificate/detail.vue")
            },
            // {
            //     path: '/myApplyFor',
            //     name: 'myApplyFor',
            //     meta: {
            //         name: "我的申请"
            //     },
            //     component: () =>
            //         import("@/views/my/my-apply-for/list.vue")
            // },
            // {
            //     path: '/myApplyForDetail',
            //     name: 'myApplyForDetail',
            //     meta: {
            //         name: "我的申请详情",
            //         downHidde: true
            //     },
            //     component: () =>
            //         import("@/views/my/my-apply-for/detail.vue")
            // },
            {
                path: "/myNotice",
                name: "myNotice",
                meta: {
                    parentName: "通知中心",
                    downHidde: true
                },
                component: () =>
                    import("@/views/profile/my-notice.vue")
            },
            {
                path: '/applySubsidy',
                name: 'applySubsidy',
                meta: {
                    name: "申请补贴",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-subsidy/apply.vue")
            },
            {
                path: '/applySubsidyOthers',
                name: 'applySubsidyOthers',
                meta: {
                    name: "代申请补贴",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-subsidy/apply-others.vue")
            },
            {
                path: '/applySubsidyFace',
                name: 'applySubsidyFace',
                meta: {
                    name: "本人校验",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-subsidy/apply-face.vue")
            },
            {
                path: '/applyLoan',
                name: 'applyLoan',
                meta: {
                    name: "申请贷款",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-loan/apply.vue")
            },
            {
                path: '/productLoan',
                name: 'productLoan',
                meta: {
                    name: "贷款产品",
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-loan/product.vue")
            },
            {
                path: '/detailFarmerLoanPass',
                name: 'detailFarmerLoanPass',
                meta: {
                    name: "贷款详情", // 农户贷 补资料和通过的详情页面
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-loan/detail-farmer-loan-pass.vue")
            },
            {
                path: '/detailFarmerLoanNoPass',
                name: 'detailFarmerLoanNoPass',
                meta: {
                    name: "贷款详情", //农户贷 不通过的详情页面
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-loan/detail-farmer-loan-nopass.vue")
            },

            {
                path: '/detailMortgagePass',
                name: 'detailMortgagePass',
                meta: {
                    name: "贷款详情", // 抵押贷款 补资料和通过的详情页面
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-loan/detail-mortgage-pass.vue")
            },
            {
                path: '/detailMortgageNoPass',
                name: 'detailMortgageNoPass',
                meta: {
                    name: "贷款详情", //抵押贷款不通过的详情页面
                    downHidde: true
                },
                component: () =>
                    import("@/views/my/my-loan/detail-mortgage-nopass.vue")
            },
            {
                path: "loanCollection",
                name: "loanCollection",
                hidden: true,
                meta: {
                    name: "农户贷",
                    parentName: "产权流转交易中心",
                    downHidde: true
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/info-collection/loan.vue"
                    )
            },
            {
                path: "loanUpload",
                name: "loanUpload",
                hidden: true,
                meta: {
                    name: "农户贷上传资料",
                    parentName: "产权流转交易中心",
                    downHidde: true
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/info-collection/loanUpload.vue"
                    )
            },
            {
                path: "companyLoanCollection",
                name: "companyLoanCollection",
                hidden: true,
                meta: {
                    name: "企业抵押贷款",
                    parentName: "产权流转交易中心",
                    downHidde: true
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/info-collection/companyLoan.vue"
                    )
            },
            {
                path: "companyLoanUpload",
                name: "companyLoanUpload",
                hidden: true,
                meta: {
                    name: "企业抵押贷款上传资料",
                    parentName: "产权流转交易中心",
                    downHidde: true
                },
                component: () =>
                    import(
                        "@/views/property-exchange-center/info-collection/companyLoanUpload.vue"
                    )
            },
            {
                path: 'companyApplyLoan',
                name: 'companyApplyLoan',
                meta: {
                    name: "企业申请贷款",  //选择贷款银行
                    parentName: "产权流转交易中心",
                    downHidde: true
                },
                component: () =>
                    import("@/views/property-exchange-center/info-collection/companyApplyLoan.vue")
            },
            {
                path: 'personApplyLoan',
                name: 'personApplyLoan',
                meta: {
                    name: "个人抵押申请贷款",  //选择贷款银行
                    parentName: "产权流转交易中心",
                    downHidde: true
                },
                component: () =>
                    import("@/views/property-exchange-center/info-collection/personApplyLoan.vue")
            },

            ]
        },
        // 二级导航-公告
        {
            path: 'Subnav',
            name: 'Subnav',
            meta: {
                navbarHidden: true,
                parentName: "二级导航"
            },
            component: () =>
                import("@/views/subnav/index.vue"),
            children: [{
                path: "exchange-project",
                name: "exchangeProject",
                meta: {
                    name: "交易项目",
                    parentName: "首页"
                },
                component: () =>
                    import("@/views/subnav/exchangeProject.vue")
            },
            {
                path: "offline-project",
                name: "offlineProject",
                meta: {
                    name: "线下项目",
                    parentName: "首页"
                },
                component: () =>
                    import("@/views/subnav/offlineProject.vue")
            },
            {
                path: "mortgage-announcement",
                name: "mortgageAnnouncement",
                meta: {
                    name: "抵押公告",
                    parentName: "首页"
                },
                component: () =>
                    import("@/views/subnav/mortgageAnnouncement.vue")
            },
            {
                path: "announcement-list",
                name: "announcementList",
                meta: {
                    name: "政策法规",
                    parentName: "首页"
                },
                component: () =>
                    import("@/views/subnav/announcement/index.vue")
            },
            {
                path: "announcement-detail",
                name: "announcementDetail",
                meta: {
                    name: "公告详情",
                },
                component: () =>
                    import("@/views/subnav/announcement/detail.vue")
            },
            ]
        }
    ]
}];

// 解决重复点击导航路由报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

const router = new VueRouter({
    routes
});
router.beforeEach((to, from, next) => {
    NProgress.start()
    next()
})

router.afterEach((to) => {
    NProgress.done()
})
export default router;
